import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { PartnerlistComponent } from './partnerlist/partnerlist.component';
import { EmployeeListComponent } from './employee-list/employee-list.component';
import { AddEmployeeComponent } from './add-employee/add-employee.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { HomeComponent } from './home/home.component';
import { TscComponent } from './tsc/tsc.component';
import { DownloadComponent } from './download/download.component';
import { UploadinventoryComponent} from './uploadinventory/uploadinventory.component';
import { InventoryAssignComponent} from './inventory-assign/inventory-assign.component';
import { UploadItemComponent } from './upload-item/upload-item.component';
import { RemoveinventoryComponent } from './removeinventory/removeinventory.component';
import { ReorderStatusComponent } from './reorder-status/reorder-status.component';
import { TscReorderApprovalComponent } from './tsc-reorder-approval/tsc-reorder-approval.component';
import { UploadapprovalitemsComponent } from './uploadapprovalitems/uploadapprovalitems.component';
import { AuthGaurdService } from './auth-gaurd.service';
import { UploadMultipleEmployeeComponent } from './upload-multiple-employee/upload-multiple-employee.component';

const routes: Routes = [
 
  { path: 'employee/view-employee', component: EmployeeListComponent,canActivate:[AuthGaurdService] },
  { path: 'employee/add-employee', component: AddEmployeeComponent,canActivate:[AuthGaurdService] },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent,canActivate:[AuthGaurdService] },
  { path : 'home', component : HomeComponent,canActivate:[AuthGaurdService]},
  { path : 'employee', component : TscComponent,canActivate:[AuthGaurdService]},
  { path : 'uploadmultipleemployee', component : UploadMultipleEmployeeComponent,canActivate:[AuthGaurdService]},
  { path : 'download', component : DownloadComponent,canActivate:[AuthGaurdService]},
  { path : 'uploadinventory', component : UploadinventoryComponent,canActivate:[AuthGaurdService]},
  { path : 'uploadmaster', component : UploadItemComponent,canActivate:[AuthGaurdService]},
  { path : 'assign', component : InventoryAssignComponent,canActivate:[AuthGaurdService]},
  { path : 'removeinventory', component : RemoveinventoryComponent,canActivate:[AuthGaurdService]},
  { path : 'reorderstatus', component : ReorderStatusComponent,canActivate:[AuthGaurdService]},
  { path : 'tscreoderapproval/approvalpage', component : TscReorderApprovalComponent},
  { path : 'uploadapprovalitems', component : UploadapprovalitemsComponent,canActivate:[AuthGaurdService] }
];

@NgModule({

  imports: [RouterModule.forRoot(routes, { useHash: true })],

  exports: [RouterModule]

})
export class AppRoutingModule { }
